import React from "react";

const FitToPageVertical = () => (
  <svg width={9} height={22}>
    <path
      d="M1.103 5.221h2.064v11.554H1.105c-.53 0-.804.625-.438 1.003l3.353 3.486c.24.314.72.314.959 0l3.354-3.486c.364-.378.091-1.003-.438-1.003H5.833V5.221h2.064c.528 0 .8-.623.436-1L4.977.735a.603.603 0 00-.956 0L.667 4.221c-.366.377-.092 1 .436 1"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export default FitToPageVertical;
